// [GEN-AI-ASSISTED]
window.mcb = window.mcb || {};
window.mcb.onetrust = (function () {
  const _logger = window.mcb.utilities.createLogger('onetrust', 'OneTrust Sync');

  // The page was rendered with the user's current consent baked in (Adobe
  // Launch is either emitted as text/javascript or text/plain + optanon-category
  // depending on consent at request time). When consent changes after load we
  // reload so the server re-renders with the new state -- but only if the
  // active consent groups actually differ from what the page was rendered
  // with. This guards against:
  //   - OneTrust firing OnConsentChanged for non-meaningful events
  //   - Rapid toggles that end up at the same final state
  //   - Any reload loop where the post-reload state matches the baseline
  const normalizeGroups = function (raw) {
    if (raw === null || raw === undefined) {
      return '';
    }
    return String(raw)
      .split(',')
      .map(function (g) { return g.trim(); })
      .filter(function (g) { return g.length > 0; })
      .sort()
      .join(',');
  };

  // Snapshot the consent groups the page was rendered with. OneTrust exposes
  // the currently-active group list on window.OnetrustActiveGroups.
  const baselineGroups = normalizeGroups(window.OnetrustActiveGroups);

  const onConsentChanged = function () {
    const currentGroups = normalizeGroups(window.OnetrustActiveGroups);
    if (currentGroups === baselineGroups) {
      _logger.trace('Consent change event received but active groups unchanged - skipping reload');
      return;
    }
    _logger.trace('Consent groups changed (' + baselineGroups + ' -> ' + currentGroups + ') - reloading page');
    location.reload();
  };

  // Wait for OneTrust to expose its consent-change hook, then subscribe.
  // Bounded retry to avoid an infinite poll if OneTrust never loads.
  const maxAttempts = 100; // ~10s at 100ms
  let attempts = 0;
  const registerListener = function () {
    if (window.OneTrust && typeof window.OneTrust.OnConsentChanged === 'function') {
      window.OneTrust.OnConsentChanged(onConsentChanged);
      _logger.trace('Registered OneTrust consent listener (baseline groups: ' + baselineGroups + ')');
      return;
    }

    if (++attempts >= maxAttempts) {
      _logger.warn('OneTrust did not become available - consent listener not registered');
      return;
    }

    setTimeout(registerListener, 100);
  };

  registerListener();
})();
